export const BASE_URL = "https://k1wb7nbg4i.execute-api.us-east-1.amazonaws.com/prd/";
export const MEDIA_URL = "https://boletim-images.s3.us-east-1.amazonaws.com/alunos/ADM/"; // S3 url